<template>
    <section class="main" v-loading="isLoading">
        <plat-form-component @updateData="updateData" :option="{dateRadio: false}"></plat-form-component>
        <transaction-component :resultDataSum="resultDataSum" :salePlatform="salePlatform"></transaction-component>
        <trends-component :resultDataDaily="resultDataDaily" :salePlatform="salePlatform"></trends-component>
    </section>
</template>

<style lang="scss" scoped="scoped">
    * {
        margin: 0;
        padding: 0;
    }
    .main {
        min-height: 100%;
        background-color: #F7F9FA;
        padding: 20px 0;
    }
</style>

<script>
    import PlatFormComponent from '../components/PlatForm.vue'
    import TransactionComponent from './components/transaction/Transaction.vue'
    import TrendsComponent from './components/trends/Trends.vue'
    import menpiaoDataPlatform from 'api/menpiaoDataPlatform'
    import MomentFormat from '../../filters/moment-format'

    export default {
        components: {
            PlatFormComponent,
            TransactionComponent,
            TrendsComponent
        },
        data () {
            const data = {
                resultDataSum: {},
                resultDataDaily: {},
                salePlatform: 0, // 平台
                date: {
                    startDate: MomentFormat.getSevenDate(),
                    endDate: MomentFormat.getYestoday()
                },
                isLoading: false
            }
            return data;
        },
        methods: {
            // 获取数据
            getData () {
                this.isLoading = true;
                menpiaoDataPlatform.getIndexData(this.salePlatform, this.date.startDate, this.date.endDate, true)
                    .then((res) => {
                        console.log(res);
                        if (res.status === 0) {
                            this.resultDataSum = res.data.sum || {};
                            this.resultDataDaily = res.data.daily || [];
                        } else {
                            this.$notify.error({
                                title: '错误',
                                message: res.message || '请求失败'
                            })
                        }
                        this.isLoading = false;
                    })
                    .catch((err) => {
                        console.log(err);
                        this.isLoading = false;
                    })
            },

            // 更新数据
            updateData (params) {
                this.salePlatform = params.salePlatform;
            }
        },
        created () {
            this.getData();
        }
    }
</script>



// WEBPACK FOOTER //
// Main.vue?19501142